<template>
  <div
    class="flex-row align-items-center gap-md pb-xs border-grey-less-transparent"
    style="border-bottom-width: 1px; border-bottom-style: solid; cursor: pointer"
    @click="$emit('click')"
  >
    <dd-checkbox :checked="selected"/>
    <h4 class="m-0 color-primary">{{ name }}</h4>
    <p class="m-0 flex-stretch" style="text-align: right">{{ email }}</p>
  </div>
</template>

<script>
import CustomerUtils from '~/util/customer';
import DamageApi from '~/api/damage';
import MortgageApi from '~/api/mortgage';
import UserApi from '~/api/user';
import CustomerApi from '~/api/customer';
import AgencyApi from '~/api/agency';
import OfficeApi from '~/api/office';
import RecipientCategoryEnum from './RecipientCategoryEnum';
import {mapState} from "vuex";

export default {
  name: "RecipientRowComponent",
  emits: ['click'],
  props:{
    name:{
      value: String,
      required: true
    },
    email:{
      value: String,
      required: true
    },
    selected:{
      value: Boolean,
      required: true
    },
  }
};
</script>
